// extracted by css-extract-rspack-plugin
export default {"gridTemplateColumns":"_ed902843"};